import type { InsertLinkHandler } from '../types/InsertLinkHandler';
import { AttachmentFileList, createCloudFileFromDataProviderItem } from 'owa-attachment-file-types';
import { FileProviderItemViewState, SelectedFilesSource } from 'owa-filepicker';

export function onFilesSelectedForInsert(
    insertLinkHandler: InsertLinkHandler,
    selectedFiles: File[] | FileProviderItemViewState[],
    source: SelectedFilesSource,
    targetWindow: Window
): void {
    if (!selectedFiles || selectedFiles.length === 0) {
        return;
    }

    if (source === SelectedFilesSource.ProviderFiles) {
        const files = <FileProviderItemViewState[]>selectedFiles;
        const providerType = files[0].model.ProviderType;
        const attachmentFileList: AttachmentFileList = files.map(viewState =>
            createCloudFileFromDataProviderItem(viewState.model)
        );

        insertLinkHandler({
            files: attachmentFileList,
            dataProviderType: providerType,
            targetWindow,
        });
    }
}
